import { IExportPlugin, PluginType } from '@/version-types';
import ShortcutMenuView from './views/shortcut';

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 0,
    name: 'shortcut-menu',
    render() {
        return <ShortcutMenuView />;
    },
};

export default exportPlugin;
